<template>
  <div>
    <UserProfile :userProfile="userProfile" v-if="userProfile" :own="false" />
    <ErrorView class="w-full" v-if="profileError" :error="profileError" />
    <div v-if="userProfile && !userProfile?.verified">
      <div>
        <h1 v-if="spotPreviews && spotPreviews.length"
            class="font-bold text-center mb-3">
          Spots</h1>
      </div>

      <SpotList :spotPreviews="spotPreviews" :lastPage="lastPage"
                :spotPreviewStatus="spotPreviewsStatus"
                :error="spotPreviewsError"
                :onLoadMore="loadMoreSpots" />

    </div>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp()

const route = useRoute();
const nameOrOldId = route.params.nameOrOldId;
const page = useState(() => 0);
const pageSize = ref(15);
const lastPage = useState(() => false);

const { data: userProfile, error: profileError } = await useAPI<UserProfile>('users/' + nameOrOldId + '/profile');

const {
  data: spotPreviews,
  error: spotPreviewsError,
  refresh: refreshSpotPreviews,
  status: spotPreviewsStatus
} = await useAsyncData('spotPreviews', async () => {
  const result = await $api<SpotPreviewsResponse>('users/' + nameOrOldId + '/spots', {
    query: {
      size: (page.value + 1) * pageSize.value
    }
  });
  lastPage.value = result.lastPage;

  return result.spotPreviews;

});

const loadMoreSpots = () => {
  page.value++;
  refreshSpotPreviews();
};

</script>
